/**
 * Drives the simulated AIS source: seeds synthetic vessels near the boat (or the
 * training centre) and advances them on a timer, so the AIS layer and the CPA
 * alarms have something to work on over the fictional area. Only runs when the
 * source is 'sim' and AIS is enabled; the real sources feed the store directly.
 */
import { useEffect } from 'react';
import { useAisStore } from '@/store/ais';
import { useChartPlotterStore } from '@/store';
import { makeSimTargets, stepTargets } from '@/ais/sim';

const TRAINING_CENTRE: [number, number] = [-5.9, 46.05];
const TICK_MS = 2000;

export function AisSimRunner() {
  const source = useAisStore((s) => s.source);
  const enabled = useAisStore((s) => s.enabled);
  useEffect(() => {
    if (source !== 'sim' || !enabled) return;
    const centre = (): [number, number] =>
      useChartPlotterStore.getState().ownship.position ?? TRAINING_CENTRE;
    // Seed once if empty.
    if (Object.keys(useAisStore.getState().targets).length === 0) {
      useAisStore.getState().upsertMany(makeSimTargets(centre()));
    }
    const id = window.setInterval(() => {
      const cur = Object.values(useAisStore.getState().targets);
      useAisStore.getState().upsertMany(stepTargets(cur, TICK_MS / 1000, centre()));
    }, TICK_MS);
    return () => window.clearInterval(id);
  }, [source, enabled]);
  return null;
}
